import { render, staticRenderFns } from "./filedCourse.vue?vue&type=template&id=f4360e60&scoped=true"
import script from "./filedCourse.vue?vue&type=script&lang=ts"
export * from "./filedCourse.vue?vue&type=script&lang=ts"
import style0 from "./filedCourse.vue?vue&type=style&index=0&id=f4360e60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4360e60",
  null
  
)

export default component.exports